const styles = {
    profileField: {
        marginTop: '24px',
    },
    saveUser: {
        background: '#3876AA',
        borderRadius: '16px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#FFFFFF',
        textAlign: 'center',
        textTransform: 'none',
        padding: '8px',
        gap: '12px',
        width: 287,
    },
    sendResetLink: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        textAlign: 'center',
        textTransform: 'none',
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-around',
        marginTop: '40px',
    },
};
export default styles;
